export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-899.78de8415.jpg";